import {
  Box,
  Button,
  CircularProgress,
  Modal,
  Typography,
} from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";

interface AddUserConfirmationModalProps {
  showAddUserConfirmationModal: boolean;
  setShowAddUserConfirmationModal: React.Dispatch<
    React.SetStateAction<boolean>
  >;
  handleSubmit: (action: string) => void;
  showLoader: boolean;
  userData:any
}

const AddUserConfirmationModal: React.FC<AddUserConfirmationModalProps> = ({
  showAddUserConfirmationModal,
  setShowAddUserConfirmationModal,
  handleSubmit,
  showLoader,
  userData,
}) => {
  const { addUserloading } = useSelector((state: any) => state.addUser);

  return (
    <Modal
      open={showAddUserConfirmationModal}
      onClose={() => setShowAddUserConfirmationModal(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: "relative",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "80%", sm: "45%" },
          bgcolor: "#fcfcfc",
          boxShadow: 24,
          borderRadius: "4px",
          pt: 2,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <Box className="px-2 py-2 md:px-4">
          <Typography
            sx={{
              fontSize: "24px",
              display: "flex",
              justifyContent: "center",
              fontWeight: 700,
              color:"#4D4D4D"
              
            }}
          >
            Are You Sure
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: { xs: "2rem", sm: "4rem" },
            }}
          >
            <Typography sx={{fontWeight:400,color:"#000000"}}>Are you sure you want to add <strong style={{color:"#000000"}}>{userData?.firstName} {userData?.lastName}?</strong></Typography>
            <Box className="flex flex-col gap-4 ">
              <Button
                sx={{
                  textTransform: "none",
                  backgroundColor: "#F2F2F2",
                  border: "1px solid rgba(0, 0, 0, 0.2)",
                  color: "rgba(40, 40, 40, 1)",
                  padding: "0.5rem 0 0.5rem 0",
                }}
                onClick={() => setShowAddUserConfirmationModal(false)}
              >
                No
              </Button>
              <Button
                sx={{
                  textTransform: "none",
                  backgroundColor: "#0077B2",
                  color: "#FFFFFF",
                  padding: "0.5rem 0 0.5rem 0",
                  marginBottom: "1rem",
                }}
                onClick={() => handleSubmit("submit")}
              >
                <Typography className="!flex !gap-2 !items-center">
                  {showLoader && addUserloading && (
                    <CircularProgress style={{ color: "white" }} size="20px" />
                  )}
                  Yes
                </Typography>
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default AddUserConfirmationModal;
